import { Component, Input } from '@angular/core';
import { UserVisualizedOccasionInfoDto } from 'src/app/data/models/dto/user-visualized-occasion-info.dto';

@Component({
  selector: 'app-user-item',
  templateUrl: './user-item.component.html',
  styleUrls: ['./user-item.component.scss'],
})
export class UserItemComponent {
  @Input() userItem: UserVisualizedOccasionInfoDto | undefined;

  constructor() {}
}
